import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchUsersParams, UserDto, UserInfosDto, UserInfosiCourrierDto } from '../interfaces/users';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private iAdminURL;
  private iCourrierURL;
  private iContactAdminURL: string;
  private iContactiCourrierURL: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iAdminURL = config.iAdminApiBaseURL;
    this.iCourrierURL = config.apiICourrierBaseUrl;
    this.iContactAdminURL = config.apiContactAdminBaseUrl;
    this.iContactiCourrierURL = config.apiContactiCourrierV1BaseUrl;
  }

  public fetchUsersFromiAdmin(options?: SearchUsersParams): Observable<UserDto[]> {
    return this.http.get<UserDto[]>(`${this.iContactAdminURL}/Global/users`, { params: options ? { ...options } : {} });
  }

  getUserWithData(data?: SearchUsersParams): Observable<UserDto[]> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<UserDto[]>(`${this.iContactiCourrierURL}/Global/users?${params}`);
  }

  public fetchUserInfos(): Observable<UserInfosDto> {
    return this.http.get<UserInfosDto>(`${this.iAdminURL}/Me/UserInfo`);
  }

  public fetchUserInfosiCourrier(): Observable<UserInfosiCourrierDto> {
    return this.http.get<UserInfosiCourrierDto>(`${this.iCourrierURL}/Me/UserInfo`);
  }
}
